import React, { useMemo } from 'react';
import AbrdnButton from '@/components/Generic/Buttons/AbrdnButton';
import styles from './FundInFocus.module.scss';
import { ComponentProps } from 'lib/component-props';
import { useI18n } from 'next-localization';
import sanitizeURL from 'lib/utils/sanitizeUrl';

type FundDetails = {
  fundName: string;
  shareClassName: string;
  relativeLink: {
    value: {
      href: string;
      text: string;
      linktype: string;
      url: string;
      class: string;
    };
  };
};

type Fields = {
  fundInFocus?: {
    value?: {
      fundName: string;
      shareClassName?: string;
      shareClassDetailsPageUrl: string;
    };
  };
};

type FundInFocusProps = ComponentProps & {
  fields?: Fields;
};

const FundInFocus: React.FC<FundInFocusProps> = ({ fields = {} }) => {
  const { t } = useI18n();

  const fundDetails: FundDetails | null = useMemo(() => {
    if (!fields.fundInFocus?.value) return null;
    return {
      fundName: fields.fundInFocus.value.fundName,
      shareClassName: fields.fundInFocus.value.shareClassName || '',
      relativeLink: {
        value: {
          href: sanitizeURL(fields.fundInFocus.value.shareClassDetailsPageUrl),
          text: '',
          linktype: '',
          url: '',
          class: '',
        },
      },
    };
  }, [fields.fundInFocus]);

  if (!fundDetails) {
    return null;
  }

  return (
    <div className="col-md-6 col-xl-4 d-flex flex-column">
      <div
        className={`${styles.fundInFocus} background-white px-2 py-3 h-100 d-flex flex-column align-items-start`}
      >
        <h5 className="text-link mb-3">{fundDetails.fundName}</h5>
        <p className="section-header-small text-uppercase text-grey">{t('shareClass')}</p>
        <h6 className="mt-1">{fundDetails.shareClassName}</h6>
        <div className="btn-wrapper mt-auto">
          <AbrdnButton
            buttonType="secondary"
            className="mt-3 override--light-background"
            linkField={fundDetails.relativeLink}
          >
            <span>{t('moreDetails')}</span>
          </AbrdnButton>
        </div>
      </div>
    </div>
  );
};

export default FundInFocus;
